'use client'

import React from 'react'
import { Heading, Subheading } from 'fuse_common/components/ui//heading'
import { Button } from 'fuse_common/components/ui/button'
import { addError } from 'fuse_common/utils/logs/client-monitoring'
import { Map, mapCoordinatesStore } from '@/components/map'
import { Logo } from '@/components/logo'
import 'fuse_common/styles/globals.css'

export const GlobalErrorView: React.FC<{
  reset?: () => void
  debugKey: string
  debugData: any
}> = ({ reset, debugKey, debugData }) => {
  React.useEffect(() => {
    const uniqueKey = Math.random().toString(36).slice(2)
    console.error(
      `GlobalErrorView is rendered [${uniqueKey}][1], ${debugKey}, log with debugData is sent in the next log`,
    )
    console.error(`GlobalErrorView is rendered [${uniqueKey}][2], ${debugKey}:${JSON.stringify(debugData)}`)
    addError(new Error('GlobalErrorView is rendered'), { cause: { uniqueKey, debugKey, debugData } })
  }, [debugData, debugKey])
  React.useEffect(() => {
    mapCoordinatesStore.set({
      ...mapCoordinatesStore.get(),
      showLogo: false,
      definedCoordinates: false,
      blur: true,
      showHomes: false,
      showMarker: false,
      clipRect: false,
    })
  }, [])
  const reloadHandler = React.useCallback(() => {
    if (reset) reset()
    else window.location.reload()
  }, [reset])

  return (
    <div className="h-[100dvh] w-full">
      {reset && <Map enforcedTheme="light" />}
      <div className="flex flex-col justify-between h-[100dvh]">
        <div className="p-4">
          <Logo className="!text-primary" />
        </div>
        <div className="flex flex-col justify-end h-full gap-10 p-8 text-primary">
          <Heading>Oops! Something Went Wrong.</Heading>
          <Subheading>
            We encountered an issue while processing your request, and our system has automatically reported it to our
            team for investigation. Please try reloading the page, or return to the homepage. If the problem continues,
            feel free to reach out, and we&apos;ll be happy to help. We apologize for the inconvenience and appreciate
            your patience.
          </Subheading>
          <div className="flex gap-4 flex-wrap">
            <Button appearance="primary" href="mailto:support@fuseenergy.com">
              Contact Support
            </Button>
            <Button appearance="secondary" href="https://www.fuseenergy.com">
              Go to main page
            </Button>
            <Button appearance="secondary" onClick={reloadHandler}>
              Reload page
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
